import { render, staticRenderFns } from "./Action.Detail.vue?vue&type=template&id=661271eb&"
import script from "./Action.Detail.vue?vue&type=script&lang=js&"
export * from "./Action.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports